export default {"src":"/_next/static/media/news-hirarechy.f0e884f4.svg","height":361,"width":178,"blurWidth":0,"blurHeight":0};